import type { Op } from 'quill/core';

const BLOCK_EMBEDS = [
  'attachment',
  'code-embed',
  'delayed-render-block-group',
  'embed',
  'card',
  'hr',
  'image',
  'iframe',
  'table-embed',
  'video',
  'button',
  'file',
] as const;

type BlockEmbedKey = (typeof BLOCK_EMBEDS)[number];

const blockEmbedsSet = new Set(BLOCK_EMBEDS);

function isBlockEmbedKey(key: string): key is BlockEmbedKey {
  return blockEmbedsSet.has(key as BlockEmbedKey);
}

const parseBlockEmbed = (op: Op): [null, null] | [BlockEmbedKey, unknown] => {
  if (op.insert && typeof op.insert === 'object') {
    const key = Object.keys(op.insert)[0];
    if (key && isBlockEmbedKey(key)) {
      return [key, op.insert[key]];
    }
  }
  return [null, null];
};

export default parseBlockEmbed;
